import { ALERTS_ENDPOINT, DEFAULT_CONFIG_ENDPOINT, DEFAULT_SESSION_ENDPOINT } from '@eucoms/common-components';

import { commonConstants } from '@config/constants/common';
import { Constants } from '@config/constants/constants.interface';

// export const baseUrl = 'https://d-c-euweb-voc-comed-ui-01.azurewebsites.net';
export const baseUrl = 'https://d-c-euweb-voc-bge-ui-01.azurewebsites.net';
// export const baseUrl = 'https://d-c-euweb-voc-bge-ui-01.azurewebsites.net';
// export const baseUrl = 'https://d-c-euweb-voc-pepco-ui-01.azurewebsites.net';
// export const baseUrl = 'https://d-c-euweb-voc-dpl-ui-01.azurewebsites.net';
// export const baseUrl = 'https://d-c-euweb-voc-ace-ui-01.azurewebsites.net';

export const constantsPattern: Constants = {
  ...commonConstants,
  isProvidingGTM: false,
  isUsingSignInCredentials: true,

  CoreServicesInitOptions: {
    configEndpoint: baseUrl + DEFAULT_CONFIG_ENDPOINT,
    sessionEndpoint: baseUrl + DEFAULT_SESSION_ENDPOINT,
    alertsEndpoint: baseUrl + ALERTS_ENDPOINT,

    additionalConfig: {
      common: {
        baseUrl,
      }
    },
  },

  devAuthHooks: ['authGuard'],
  signInCredentials: {
    USER: 'upm10000095013',
    PASSWORD: 'Password1',
    SMAUTHREASON: 0
  },

  paymentusUrl: 'https://comd-sit-623.paymentus.io/xotp/pm/comd',
  oPowerURLBase() {
    return sessionStorage.getItem('oPowerURLBase');
  },
};
